import { Button, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import "./NoAuthenticationPage.scss"
import { Tooltip } from '@mui/material';
import { PDF_URL, SNOW_TICKET_URL, ENDPOINTS, } from 'src/constants';
import QuestionMarkIcon from '@mui/icons-material/QuestionMark';
import { navigateTo } from 'src/utils/navigateHelper';
// custom style for typography
const StyledTypography = styled(Typography)`
  color: ${({ theme }) => theme.palette.primary.dark};
  font-weight: bold;
`;
export default function NoAuthenticationPage() {
    return (
        <div className="error-page">
            <img src='/static/images/ppaEdge.png' alt="PPA Edge" className="error-page-img" />
            <img src='/static/images/noAccess.png' alt="No Access" className="error-page-img" />
            <StyledTypography variant='h1' className="error-message-failed">
                Your authentication failed
            </StyledTypography >
            <StyledTypography className="error-details" >
                Currently you do not have access to PPA EDGE.
                <br />
                Please click below to raise an access request or learn how.
            </StyledTypography>
            <div className="button-question">
                <Button
                    className="request-button"
                    onClick={() => window.open(SNOW_TICKET_URL, '_blank')}
                >
                    Raise access request
                </Button>
                <Tooltip
                    title="Click here for guidance on raising a access request."
                    arrow
                    PopperProps={{
                        modifiers: [
                            {
                                name: 'zIndex',
                                enabled: true,
                                phase: 'main',
                                fn: ({ state }) => {
                                    state.styles.popper.zIndex = "200000"; // Higher than .error-page
                                },
                            },
                        ],
                    }}
                >
                    <span style={{ display: 'inline-flex', cursor: 'pointer' }}>
                        <QuestionMarkIcon
                            className="question-icon"
                            onClick={() => window.open(PDF_URL, '_blank')}
                        />
                    </span>
                </Tooltip>
            </div>
            <StyledTypography className="error-details">
                If you were previously able to access PPA EDGE, your session has expired, please close the browser and retry.
                <br />
                If the issue persists, please raise a ticket in SNOW via the link below.
            </StyledTypography>
            <div className='ticket-home-button'>
                <Button
                    className="request-button"
                    onClick={() => window.open(SNOW_TICKET_URL, '_blank')}
                >
                    Raise a ticket
                </Button>
                <Button
                    className="request-button"
                    onClick={() => navigateTo(ENDPOINTS.homeUrl)}
                >
                    Go to Home Page
                </Button>
            </div>
        </div >
    );
}